import { Button, FormBuilder, Div, KeyboardAvoidingDiv, Label, Touchable } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { Logo } from "../../layout/components/logo";
import { loginForm } from "./Login.types";
import { useLogin } from "./useLogin";

export default function LoginScreen() {
  const { login, loading, gotToForgotPassword } = useLogin();
  return (
    <ScreenLayout footer={false}>
      <KeyboardAvoidingDiv>
        <Div classNames={["flex1", "alignItemsCenter", "justifyContentCenter", "p16"]}>
          <Logo width={200} height={200} />
          <Div classNames={["mt-{20}", "w-{100%}", "maxW-{300}"]}>
            <FormBuilder
              form={loginForm}
              onSubmit={login}
              submitControl={(submit) => (
                <>
                  <Touchable onPress={gotToForgotPassword}>
                    <Label type="l3Regular" classNames={["underline"]}>
                      Forgot password?
                    </Label>
                  </Touchable>
                  <Button
                    title="Log in"
                    onPress={submit}
                    classNames={["btn", "btnBlock", "btnPrimary", "mt-{22}"]}
                    isLoading={loading}
                    disabled={loading}
                  />
                </>
              )}
              submitFormOnEnter={true}
            />
          </Div>
        </Div>
      </KeyboardAvoidingDiv>
    </ScreenLayout>
  );
}
